import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const OrdersApiService = {
  getMyOrders: async () => {
    const response = await api.request({
      url: `/api/Orders/GetMyOrders`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getOrderDetails: async (orderId) => {
    const response = await api.request({
      url: `/api/Orders/GetOrderWithItems?id=${orderId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  createOrder: async (orderData) => {
    const response = await api.request({
      url: `/api/Orders/CreateOrder`,
      method: "POST",
      data: orderData,
      headers: authHeader(),
    });
    return response.data;
  },

  calculateOrderTotal: async (orderData) => {
    const response = await api.request({
      url: `/api/Orders/CalculateOrderTotal`,
      method: "POST",
      data: orderData,
      headers: authHeader(),
    });
    return response.data;
  },

  updateOrderStatus: async (orderId, status) => {
    const response = await api.request({
      url: `/api/Orders/UpdateOrderStatus?id=${orderId}&status=${status}`,
      method: "PUT",
      headers: authHeader(),
    });
    return response.data;
  },

  searchOrders: async (filters) => {
    const response = await api.request({
      url: `/api/Orders/SearchOrders?${queryString.stringify(filters || {})}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getUserOrders: async (userId) => {
    const response = await api.request({
      url: `/api/Orders/GetUserOrders?userId=${userId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getSupplierOrders: async (supplierId, params) => {
    const response = await api.request({
      url: `/api/Orders/GetSupplierOrders?supplierId=${supplierId}&${queryString.stringify(
        params || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default OrdersApiService;
